import '../css/category-page.scss';
import Modernizr from 'modernizr';
import {h, render} from 'preact';
import CategoryTile from './components/category/tile';
import ProductConfigurationService from '@services/ProductConfigurationService';

document.addEventListener( 'DOMContentLoaded', () => {

    // initialize category tile optionGroup preview
    if ( !window.USER_IS_TOUCHING ) {
        const categoryTiles = document.querySelectorAll( '.category-card[data-product-id]' );

        const productIds = [...categoryTiles]
            .map( item => item.getAttribute( 'data-product-id' ) );

        // todo -> data object needs to be mapped to appropriate DOM node, currently assumes data is returned in the
        // same order the DOM was queried

        // todo -> pass productIds and allow mock api to handle params
        ProductConfigurationService.getOptionGroupsCollection().then( data => {
            // console.log( 'DATA:', data );
            [...categoryTiles].forEach( ( el, i ) => {
                el.querySelector( '.card-media' ).addEventListener( 'mouseenter', function renderCategoryTile ( e ) {
                    if ( e.currentTarget.matches( '.card-media' ) ) {
                        el.removeEventListener( 'mouseenter', renderCategoryTile );
                        render( <CategoryTile {...data[i]} />, null, el );
                    }
                } )
            } )
        } );
    }

} );

